var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    color: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5203 24.0625L16.4062 17.9484V7.65625H18.5938V17.0406L24.0625 22.5203L22.5203 24.0625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.1875C15.4601 2.18779 13.441 2.59741 11.5623 3.39211C9.68356 4.18682 7.9834 5.35044 6.5625 6.81406V2.1875H4.375V10.9375H13.125V8.75H7.74375C9.79566 6.46985 12.5814 4.98042 15.6171 4.54038C18.6529 4.10034 21.7469 4.73749 24.3617 6.34117C26.9766 7.94485 28.9472 10.4138 29.9313 13.3191C30.9153 16.2244 30.8507 19.3827 29.7485 22.2453C28.6464 25.108 26.5765 27.4942 23.8982 28.9895C21.2198 30.4848 18.1024 30.9948 15.0872 30.4309C12.072 29.867 9.34953 28.2649 7.39265 25.9027C5.43577 23.5405 4.36808 20.5675 4.375 17.5H2.1875C2.1875 20.5285 3.08556 23.489 4.76812 26.0072C6.45068 28.5253 8.84217 30.4879 11.6402 31.6469C14.4382 32.8059 17.517 33.1091 20.4873 32.5183C23.4577 31.9274 26.1861 30.4691 28.3276 28.3276C30.4691 26.1861 31.9274 23.4577 32.5183 20.4873C33.1091 17.517 32.8059 14.4382 31.6469 11.6402C30.4879 8.84217 28.5253 6.45068 26.0072 4.76812C23.489 3.08556 20.5285 2.1875 17.5 2.1875V2.1875Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClock);
export default __webpack_public_path__ + "static/media/arrow-clock.6fd0fced.svg";
export { ForwardRef as ReactComponent };